module.exports = __webpack_public_path__ + "static/img/style_1.7a4263b6.png";